import Head from '~/components/Head'
import { Post } from '~/types/post'
import { PostArticle } from '~/types/postArticle'
import { PostImage } from '~/types/postImage'
import { PostLink } from '~/types/postLink'
import { PostText } from '~/types/postText'
import Posts from '~/components/Posts'
import React from 'react'
import { graphql } from 'gatsby'
import moment from 'moment'

type ViewProps = {
    data: {
        contentfulPostArticle: PostArticle | undefined
        contentfulPostImage: PostImage | undefined
        contentfulPostLink: PostLink | undefined
        contentfulPostText: PostText | undefined
    }
    pageContext: {
        institutionId?: string
        postId?: string
    }
}

function getPostSeoTitle(post: Post) {
    if (post.type === 'postArticle') {
        return (post as PostArticle).title
    } else if (post.type === 'postImage') {
        return (post as PostImage).title
    } else if (post.type === 'postLink') {
        return (post as PostLink).title
    } else {
        return (post as PostText).text.text
    }
}

function getPostSeoDescription(post: Post) {
    if (post.type === 'postArticle') {
        return (post as PostArticle).description.description
    } else if (post.type === 'postImage') {
        return (post as PostImage).description.description
    } else if (post.type === 'postLink') {
        return (post as PostLink).title
    } else {
        return (post as PostText).text.text
    }
}

export default ({ data }: ViewProps) => {
    const post: Post | undefined = data.contentfulPostArticle
        ? { ...data.contentfulPostArticle, type: 'postArticle', isPage: false }
        : data.contentfulPostImage
        ? { ...data.contentfulPostImage, type: 'postImage', isPage: false }
        : data.contentfulPostLink
        ? { ...data.contentfulPostLink, type: 'postLink', isPage: false }
        : data.contentfulPostText
        ? { ...data.contentfulPostText, type: 'postText', isPage: false }
        : undefined

    if (!post) {
        return <></>
    }

    const title = getPostSeoTitle(post)
    const url = `/feed/${post.institution!.slug}/${moment(post.createdAt).format('YYMMDDHHmmss')}`
    const description = getPostSeoDescription(post)
    const image = post.institution!.image.fluid.src

    return (
        <div>
            <Head title={title} url={url} description={description} image={image} />
            <Posts posts={[post]} />
        </div>
    )
}

export const query = graphql`
    query($institutionId: String, $postId: String) {
        contentfulPostArticle(id: { eq: $postId }, institution: { id: { eq: $institutionId } }) {
            ...postArticleFragment
            institution {
                ...institutionFragment
            }
        }
        contentfulPostImage(id: { eq: $postId }, institution: { id: { eq: $institutionId } }) {
            ...postImageFragment
            institution {
                ...institutionFragment
            }
        }
        contentfulPostLink(id: { eq: $postId }, institution: { id: { eq: $institutionId } }) {
            ...postLinkFragment
            institution {
                ...institutionFragment
            }
        }
        contentfulPostText(id: { eq: $postId }, institution: { id: { eq: $institutionId } }) {
            ...postTextFragment
            institution {
                ...institutionFragment
            }
        }
    }
`
